module.exports = __webpack_public_path__ + "img/rtb_silo_5.f4e7b9f4.png";